import store from '@/store'
import priceCalculator from '@/utils/priceCalculator'

const getters = {
  subtotal(state) {
    const productsInCart = state.productsInCart.length
      ? state.productsInCart
      : state.lastOrderProductsInCart

    return priceCalculator.calculateSubtotal(productsInCart)
  },
  unitsInCart(state) {
    const productsInCart = state.productsInCart.length
      ? state.productsInCart
      : state.lastOrderProductsInCart

    if (productsInCart.length) {
      return productsInCart.map(product => product.quantity).reduce((acc, bill) => bill + acc)
    }
    return 0
  },
  appliedCouponDiscountedPrice(state, getters) {
    const productsInCart = state.productsInCart.length
      ? state.productsInCart
      : state.lastOrderProductsInCart
    const appliedCoupon = store.get('coupons/appliedCoupon')

    return priceCalculator.calculateCouponDiscountAmount(productsInCart, appliedCoupon)
  },
  paymentMethod(state) {
    return state.paymentMethod
  },
  shippingMethod(state) {
    return state.shippingMethod
  }
}

export default getters
